export const toggleBodyScrollLock = (lock: boolean): void => {
  const body = document.querySelector('body')
  if (body != null) {
    lock ? body.style.overflow = 'hidden' : body.style.overflow = 'auto'
  }
}
